import request from '@/utils/request';
import Resource from '@/api/resource';

class UserResource extends Resource {
  constructor() {
    super('users');
  }

  permissions(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/permissions',
      method: 'get',
    });
  }

  updatePermission(id, permissions) {
    return request({
      url: '/' + this.uri + '/' + id + '/permissions',
      method: 'put',
      data: permissions,
    });
  }

  /** 获取用户可操作的广告主 */
  advertisers(id) {
    return request({
      url: '/' + this.uri + '/' + id + '/advertisers',
      method: 'get',
    });
  }

  /** 重置密码接口 */
  resetPassword(data) {
    return request({
      url: `/users/${data.id}/update`,
      method: 'post',
      data,
    });
  }

  /** 获取用户-以及搜索 */
  getUserList(data) {
    return request({
      url: `/${this.uri}`,
      method: 'get',
      params: data,
    });
  }

  /** 修改用户信息 */
  updateUser(data, id) {
    return request({
      url: `/${this.uri}/${id}/updateUser`,
      method: 'post',
      data,
    });
  }

  /** 获取组员列表 */
  getMembersList() {
    return request({
      url: `/${this.uri}/childList`,
      method: 'get',
    });
  }
}

export { UserResource as default };
